import { gql } from "@apollo/client";

export const GET_QR_FIELD_OPTIONS = gql(`
    query getQrFieldOptions {
        qrFieldOptions
    }
`);

export const GET_USER_RELATIONS = gql`
  query GetUserRelations {
    relations(first: 50) {
      data {
        id
        name
      }
    }
  }
`;
